__turbopack_context__.v({
  "aiAvatarSelect": "agent-sections-module__nPrsqa__aiAvatarSelect",
  "aiModalSection": "agent-sections-module__nPrsqa__aiModalSection",
  "aiModalSectionTitle": "agent-sections-module__nPrsqa__aiModalSectionTitle",
  "aiModalSectionTitleAlpha": "agent-sections-module__nPrsqa__aiModalSectionTitleAlpha",
  "avatarCard": "agent-sections-module__nPrsqa__avatarCard",
  "avatarGrid": "agent-sections-module__nPrsqa__avatarGrid",
  "avatarTypeSelect": "agent-sections-module__nPrsqa__avatarTypeSelect",
  "blueText": "agent-sections-module__nPrsqa__blueText",
  "botNameInput": "agent-sections-module__nPrsqa__botNameInput",
  "buttonGroup": "agent-sections-module__nPrsqa__buttonGroup",
  "configTitle": "agent-sections-module__nPrsqa__configTitle",
  "configWrapper": "agent-sections-module__nPrsqa__configWrapper",
  "container": "agent-sections-module__nPrsqa__container",
  "createAvatarSectionLeftImage": "agent-sections-module__nPrsqa__createAvatarSectionLeftImage",
  "createAvatarSectionRightImage": "agent-sections-module__nPrsqa__createAvatarSectionRightImage",
  "createAvatarSectionRoot": "agent-sections-module__nPrsqa__createAvatarSectionRoot",
  "createAvatarSectionText": "agent-sections-module__nPrsqa__createAvatarSectionText",
  "createAvatarSectionTitle": "agent-sections-module__nPrsqa__createAvatarSectionTitle",
  "createAvatarSectionWrapper": "agent-sections-module__nPrsqa__createAvatarSectionWrapper",
  "createButton": "agent-sections-module__nPrsqa__createButton",
  "darkFilter": "agent-sections-module__nPrsqa__darkFilter",
  "deployAnywhereImage": "agent-sections-module__nPrsqa__deployAnywhereImage",
  "errorText": "agent-sections-module__nPrsqa__errorText",
  "firstSectionBackground": "agent-sections-module__nPrsqa__firstSectionBackground",
  "firstSectionContent": "agent-sections-module__nPrsqa__firstSectionContent",
  "firstSectionDescription": "agent-sections-module__nPrsqa__firstSectionDescription",
  "firstSectionFeature": "agent-sections-module__nPrsqa__firstSectionFeature",
  "firstSectionFeatures": "agent-sections-module__nPrsqa__firstSectionFeatures",
  "firstSectionFeaturesContent": "agent-sections-module__nPrsqa__firstSectionFeaturesContent",
  "firstSectionGirlPic": "agent-sections-module__nPrsqa__firstSectionGirlPic",
  "firstSectionManPic": "agent-sections-module__nPrsqa__firstSectionManPic",
  "firstSectionRoot": "agent-sections-module__nPrsqa__firstSectionRoot",
  "firstSectionTM": "agent-sections-module__nPrsqa__firstSectionTM",
  "firstSectionTitle": "agent-sections-module__nPrsqa__firstSectionTitle",
  "formRow": "agent-sections-module__nPrsqa__formRow",
  "formSection": "agent-sections-module__nPrsqa__formSection",
  "fromIdeaToDeploymentSectionContent": "agent-sections-module__nPrsqa__fromIdeaToDeploymentSectionContent",
  "fromIdeaToDeploymentSectionRoot": "agent-sections-module__nPrsqa__fromIdeaToDeploymentSectionRoot",
  "fromIdeaToDeploymentSectionTitle": "agent-sections-module__nPrsqa__fromIdeaToDeploymentSectionTitle",
  "inputWrapper": "agent-sections-module__nPrsqa__inputWrapper",
  "loadingText": "agent-sections-module__nPrsqa__loadingText",
  "providerSection": "agent-sections-module__nPrsqa__providerSection",
  "quickCreation": "agent-sections-module__nPrsqa__quickCreation",
  "readyForIntegration": "agent-sections-module__nPrsqa__readyForIntegration",
  "root": "agent-sections-module__nPrsqa__root",
  "scaleUp": "agent-sections-module__nPrsqa__scaleUp",
  "sectionCardContent": "agent-sections-module__nPrsqa__sectionCardContent",
  "sectionCardWrapper": "agent-sections-module__nPrsqa__sectionCardWrapper",
  "sectionTitle": "agent-sections-module__nPrsqa__sectionTitle",
  "selectWrapper": "agent-sections-module__nPrsqa__selectWrapper",
  "selected": "agent-sections-module__nPrsqa__selected",
  "slideUp": "agent-sections-module__nPrsqa__slideUp",
  "textArea": "agent-sections-module__nPrsqa__textArea",
  "textAreaSection": "agent-sections-module__nPrsqa__textAreaSection",
  "title": "agent-sections-module__nPrsqa__title",
  "topSection": "agent-sections-module__nPrsqa__topSection",
  "typeSelect": "agent-sections-module__nPrsqa__typeSelect",
  "useCaseBigImage": "agent-sections-module__nPrsqa__useCaseBigImage",
  "useCaseSmallImage": "agent-sections-module__nPrsqa__useCaseSmallImage",
  "useCaseSmallImageContainer": "agent-sections-module__nPrsqa__useCaseSmallImageContainer",
  "useCaseSmallImageDescription": "agent-sections-module__nPrsqa__useCaseSmallImageDescription",
  "useCaseSmallImageTitle": "agent-sections-module__nPrsqa__useCaseSmallImageTitle",
  "useCaseTextWrapper": "agent-sections-module__nPrsqa__useCaseTextWrapper",
  "useCasesSectionContent": "agent-sections-module__nPrsqa__useCasesSectionContent",
  "useCasesSectionRoot": "agent-sections-module__nPrsqa__useCasesSectionRoot",
  "useCasesSectionTitle": "agent-sections-module__nPrsqa__useCasesSectionTitle",
  "violetText": "agent-sections-module__nPrsqa__violetText",
  "webSvg": "agent-sections-module__nPrsqa__webSvg",
  "whiteText": "agent-sections-module__nPrsqa__whiteText",
  "wideCard": "agent-sections-module__nPrsqa__wideCard",
});
